import React, {
  FC,
  ReactElement,
  useContext,
  useState,
  useEffect,
  useMemo,
  useCallback,
  cloneElement,
} from 'react';
import AsideBar from '@tencent/tpm-meeting-active/lib/AsideBar';
import '@tencent/tpm-meeting-active/lib/AsideBar/style';
import AddActivePanel from '@tencent/tpm-meeting-active/lib/AddActivePanel';
import '@tencent/tpm-meeting-active/lib/AddActivePanel/style';
import Menu from '@tencent/tpm-meeting-active/lib/Menu';
import '@tencent/tpm-meeting-active/lib/Menu/style';
import User from '@tencent/tpm-meeting-active/lib/User';
import '@tencent/tpm-meeting-active/lib/User/style';
import AddButton from 'src/components/AddActivityBtn/index';
import { goLogin } from '@utils/login-util';
import DefaultAvatar from '@assets/imgs/default-avatar.png';
import CustomFooter from '../CustomFooter';
import { NO_PROTOCOL_PATH } from '../CustomFooter/data';
import Link from 'next/link';
import { ExternalLink } from '@tencent/tea-component';
import Layout from '@tencent/tpm-meeting-active/lib/Layout';
import '@tencent/tpm-meeting-active/lib/Layout/style';
import { MENU_DATA, MENU_REPORT } from '@utils/layout-config';
import RedDot from '@component/RedDot';
import { getMenuList } from '@component/AccoutInfo';
import dataReport from '@utils/data-report';
import { AppContext } from '@utils/browser/app-context';
import { useAccountInfo } from '@hooks/useAccount';
import { useRouter } from 'next/router';
import styles from './index.module.scss';
import { PeopleSelect } from '@component/PeopleSelect';
import MemberOption from '@tencent/tpm-meeting-active/lib/MemberOption';
import { PayBadge } from '@tencent/calendar-web-component-pc-biz';
import useCommercialize from '@hooks/useCommercialize';
import logo from '@assets/imgs/activity-logo.svg';

const { Body, Sider, Content } = Layout;

const TempLink: FC<any> = ({ children, href, ...props }) => (
  <Link href={href}>
    <div {...props}>
      {children}
      {props.id === 'news' && (
        <RedDot redDotPath="wemeet://app.activity_space.new_message" pagePath="/news" />
      )}
    </div>
  </Link>
);

const ExternalTempLink: FC<any> = ({ children, href, ...props }) => (
  <ExternalLink href={href}>
    <div {...props}>{children}</div>
  </ExternalLink>
);

const HostPageLayout: FC<{
  isMobile?: boolean;
  children: ReactElement;
  className?: string;
  fullResponsive?: boolean;
  responsive?: boolean;
  full?: boolean;
  iswx?: boolean;
}> = ({ children, className, fullResponsive, full, responsive }) => {
  const { hostDetail, isHost, userHostList, setSelectHostId } = useContext(AppContext);
  const info = useAccountInfo();
  const router = useRouter();
  const { pathname } = useRouter();
  const [noProtocol, setNoProtocol] = useState(false);
  // todo 修改权限点
  const { vipResource } = useCommercialize();
  const commercialize = useMemo(
    () => ({
      coupon: vipResource?.rule?.coupon_switch === '0' ? 1 : 0,
      member: vipResource?.rule_type === 'free' ? 1 : 0,
      settle: vipResource?.rule_type === 'free' ? 1 : 0,
    }),
    [vipResource],
  );
  // 当前是否需要更新
  const [refreshData, updateRefreshData] = useState(false);
  // 获取带有付费标识的标题
  const getMenuTitle = useCallback(
    (menuItem: any) => {
      let title = <>{menuItem.name}</>;
      const commercializeObj: any = commercialize;
      if (menuItem?.hasPay && commercializeObj?.[menuItem?.id] === 1) {
        title = (
          <>
            {menuItem.name}
            <PayBadge className="pay-badge" type="mid"></PayBadge>
          </>
        );
      }
      return title;
    },
    [vipResource],
  );

  useEffect(() => {
    setNoProtocol(NO_PROTOCOL_PATH.includes(pathname));
  }, [pathname]);

  const [user, setUserData] = useState({
    name: '',
    imageUrl: DefaultAvatar,
    reverse: false,
  });
  const [enterSpace, setEnterSpace] = useState(false);
  const [canChangeAccount, setCanChangeAccount] = useState(false);

  // 当前用户的主办方组织权限
  const isCreated = Number(hostDetail?.role_id) === 1;
  const logoUrl = isHost ? '/events/host/home' : '/index.html';
  const menuList = useMemo(() => {
    const hostList = MENU_DATA.filter(
      (item) => !item.isHost || (item.isHost && hostDetail?.host_id),
    );
    function filterMenuItems(menuItems: any[]) {
      const filterResult: any = [];
      if (menuItems && menuItems?.length > 0) {
        menuItems.forEach((item) => {
          // 收入管理的菜单是创建者才有的权限
          if (!item.isCreated || (isCreated && item.isCreated)) {
            const newItem = { ...item };
            // 如果有子菜单，则递归
            if (newItem?.items) {
              const subMenuItems = filterMenuItems(newItem.items);
              newItem.items = subMenuItems;
            }
            filterResult.push(newItem);
          }
        });
      }
      return filterResult;
    }
    return filterMenuItems(hostList);
  }, [hostDetail?.host_id, isCreated]);

  // 主办方列表选择列表
  const hostListData = useMemo(() => {
    if (userHostList && userHostList?.length > 0) {
      return userHostList.map((x) => ({
        id: x?.host_id,
        name: x?.host_name,
        tips: x?.host_name,
        imageUrl: x?.host_avatar_url,
      }));
    }
    if (hostDetail?.host_id) {
      return [
        {
          id: hostDetail?.host_id,
          name: hostDetail?.host_name,
          tips: hostDetail?.host_name,
          imageUrl: hostDetail?.avatar_url,
        },
      ];
    }
    return [];
  }, [userHostList, hostDetail?.host_id]);
  // 切换当前选中主办方
  const changeHost = (value: any) => {
    console.log('changeHost', value);
    setSelectHostId(value, () => {
      router.push({
        pathname: '/home',
        query: {
          host_id: value,
        },
      });
    });
  };
  // 成功新建活动
  const onSuccessCreate = useCallback(() => {
    if (pathname === '/home' || pathname === '/index') {
      updateRefreshData(true);
      const seter = setTimeout(() => {
        clearTimeout(seter);
        updateRefreshData(false);
      }, 1 * 1000);
    }
  }, [pathname]);
  const goIndexPage = () => {
    if (!info?.userid && pathname === '/event/[eventid]/registration') {
      // 直接跳转登录
      goLogin();
      return;
    }
    if (hostDetail?.host_id) {
      router.push(`/home?host_id=${hostDetail.host_id}`);
    } else if (enterSpace) {
      window.location.href = '/events/square';
    } else {
      window.location.href = `${window.location.origin}/user-center`;
    }
  };
  useEffect(() => {
    if (info?.name && (info?.name !== user?.name || info?.avatar !== user?.imageUrl)) {
      setUserData({
        ...user,
        imageUrl: info?.avatar || DefaultAvatar,
        name: info?.name,
      });
    }
    if (info?.canChangeAccount !== canChangeAccount && info?.canChangeAccount !== undefined) {
      setCanChangeAccount(info?.canChangeAccount);
    }
    if (info?.enterSpace !== enterSpace && info?.enterSpace !== undefined) {
      setEnterSpace(info?.enterSpace);
    }
  }, [info, enterSpace, canChangeAccount]);

  /** 每个item点击时
   * 数据上报
   */
  const clickItem = (item: any) => {
    if (item.id && MENU_REPORT[item.id]) dataReport(MENU_REPORT[item.id]);
  };

  return (
    <Layout
      className={className}
      full={full}
      fullResponsive={fullResponsive}
      responsive={responsive}
    >
      <div className={styles.hostNavBar}>
        <a className={styles.logo} href={logoUrl}>
          <img src={logo} />
        </a>
        <User
          imageUrl={user.imageUrl}
          name=""
          onClick={goIndexPage}
          dropdownProps={{
            button: '',
            children: getMenuList(info, router.pathname, canChangeAccount),
            trigger: 'hover',
          }}
        />
      </div>
      <Body layout="horizontal">
        <Sider left>
          {/* 侧边导航 start */}
          <AsideBar active userProps={{ name: '' }} className={styles.asideBar}>
            {isHost && (
              <AddActivePanel
                desc="添加你的精彩活动"
                btn={
                  <AddButton
                    className="size-full-width  ma-add-active-panel__btn"
                    dataReportCode="e#eventplace_navigation#create_button#click"
                    onSuccessCreate={onSuccessCreate}
                  />
                }
              />
            )}
            <AsideBar.Box scrollable className={styles.asideBarMenu}>
              <Menu theme="dark">
                {menuList.map((group: any) => (
                  <Menu.Group title={group.group} key={group.key}>
                    {group.items.map((item: any) => {
                      if (item?.type === 'subMenu') {
                        return (
                          <Menu.SubMenu
                            title={item.name}
                            icon={item.icon}
                            opened={item?.pathList?.includes(pathname)}
                          >
                            {item.items.map((subItem: any) => {
                              const title = getMenuTitle(subItem);
                              return (
                                <Menu.Item
                                  element={subItem.external ? ExternalTempLink : TempLink}
                                  title={title}
                                  href={subItem.path}
                                  to={subItem.path}
                                  selected={pathname === subItem.path}
                                  onClick={() => clickItem(subItem)}
                                />
                              );
                            })}
                          </Menu.SubMenu>
                        );
                      }
                      if (item?.id === 'sponsor') {
                        return hostListData?.length > 1 ? (
                          <PeopleSelect
                            className="ma-menu__item ma-t-tag-dropdown"
                            data={hostListData}
                            selectedId={hostDetail?.host_id}
                            onChange={changeHost}
                            appearance="button"
                            matchButtonWidth
                          />
                        ) : (
                          <div className="ma-menu__item ma-t-tag-single">
                            <MemberOption
                              key={hostDetail?.host_id}
                              name={hostDetail?.host_name}
                              imageUrl={hostDetail?.avatar_url}
                            />
                          </div>
                        );
                      }
                      const title = getMenuTitle(item);
                      return (
                        <Menu.Item
                          // element={TempLink}
                          element={item.external ? ExternalTempLink : TempLink}
                          href={item.path}
                          title={title}
                          icon={item.lightIcon}
                          key={item.id}
                          selected={pathname === item.path}
                          onClick={() => clickItem(item)}
                        />
                      );
                    })}
                  </Menu.Group>
                ))}
              </Menu>
            </AsideBar.Box>
          </AsideBar>
          {/* 侧边导航 end */}
        </Sider>
        {noProtocol ? (
          <Content showBackButton={false} backButtonText={null}>
            {children}
          </Content>
        ) : (
          <Content
            showBackButton={false}
            backButtonText={null}
            className={styles['page-content-box']}
          >
            <div className={styles['page-content']}>{cloneElement(children, { refreshData })}</div>
            <div className={styles.footer}>
              <CustomFooter />
            </div>
          </Content>
        )}
      </Body>
    </Layout>
  );
};

export default HostPageLayout;
